import { Component, OnInit, NgModule, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { NgProgress } from 'ngx-progressbar';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { Subject, Subscription } from 'rxjs';
import { QuoteService } from '../../services/quote.service';
import { Quote } from '../../models/quote.model';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { sortingInfo } from '../../models/filter.model';
import { CommonService } from '../../services';
import { NgProgressService } from '../../services/ngProgress.service';
import { filter, takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-open-quotes',
  templateUrl: './open-quotes.component.html',
  styleUrls: ['./open-quotes.component.css']
})
export class OpenQuotesComponent implements OnInit, OnDestroy {

  title = 'Open Quotes';
  hasEmptyResult: boolean = false;
  loadContent: boolean = false;
  quotes: Quote[] = [];
  sortedData: Quote[] = [];
  openQuotes: Quote[] = [];
  displayedColumns: string[] = ['quote_id', 'brand', 'end_user', 'expriry_date','total_ex','action'];
  p: number = 1;

  filterInput: string;
  filterResultArr: any;
  hasEmptyFilterResult: boolean = false;

  sortingInfoObj: sortingInfo = {
    comparedProperty: '',
    sortingOrder: ''
  };

  date = new Date(Date.now());
  month: any;
  day: any;
  currentDate: string;

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; //reference to the breadcrumb

  quoteCollection$: Subscription;

  downloadSub$: Subscription;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  narrow: boolean = false;
  selectedOrder = '';
  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    public ngProgress: NgProgressService,
    private cs: CommonService,
    private quoteService: QuoteService,
  ) { }



  ngOnInit() {
    this.ngProgress.start();

    this.quoteCollection$ = this.quoteService.getQuoteList().subscribe(
      (value: Quote[]) => {

        let data = this.cs.groupBy(value, (item) => item.out_quote_id);

        for (var key in data) {
            if (data[key].length > 0) {
                const publishedVersion = data[key][0].out_published_version;
                const quote = data[key].find(item => item.out_published_version == publishedVersion);
                this.quotes.push(quote);

            } else {
                this.quotes.push(data[key][0]);
            }
        }

        if ((this.cs.toNumber(this.date.getMonth()) + 1 ) < 10) {
          this.month = '0' + (this.cs.toNumber(this.date.getMonth()) + 1).toString();
        } else {
          this.month = (this.cs.toNumber(this.date.getMonth()) + 1).toString();
        }
        if ((this.cs.toNumber(this.date.getDate()) < 10 )) {
          this.day = '0' + this.date.getDate();
        } else {
          this.day = this.date.getDate();
        }
        this.currentDate = this.date.getFullYear() + this.month + this.day;
        this.openQuotes = this.quotes.filter(x => (this.cs.toNumber(x.validTo.split("-").reverse().join("")) >= this.cs.toNumber(this.currentDate)) && (this.cs.toNumber(x.out_published_version) > 0));
        this.sortedData = this.openQuotes.slice();
        // this.quoteService.quoteList$.next(this.openQuotes.slice());
        //console.log(this.sortedData);
      }, (error: any) => {
        console.info(error);
        this.ngProgress.done();
      }
    );

    if (this.router.url !== '/quotes/openQuotes') {
      this.loadContent = true;  //set to true to avoid load two loading screen at the same time
    }

    this.router.events.pipe(
      takeUntil(this.ngUnsubscribe),
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.router.url === '/quotes/openQuotes') {
        $('#levelOne').animate({scrollLeft: -250}, 400);
        this.narrow = false;
      } else {
        this.narrow = true;
      }

    });
    this.ngProgress.done();
    this.cs.emitUpdateSideBarActiveItem('quotes');
  }
  goQuoteDetail(quote: Quote) {
    this.router.navigate(['quotesItemsDetials', quote.quoteId, quote.out_published_version], {relativeTo: this.activeRouter});
    this.selectedOrder = `${quote.quoteId}${quote.out_published_version}`;
  }
  ngOnDestroy() {
    this.cs.emitUpdateSideBarActiveItem('');
    this.ngProgress.done();
    if (this.quoteCollection$) {
      this.quoteCollection$.unsubscribe();
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/quotes');
  }

  goToNewsletterView(newsId: string): void {
    if (this.breadcrumbRef) {
      this.breadcrumbRef.ngAfterViewInit(); //recreate breadcrumb
    }
    // this.newsletterViewLoaded = true;
  }

  download(quote: Quote) {
    this.ngProgress.start();
    this.downloadSub$ = this.quoteService.downloadQuote(quote.quoteId, parseInt(quote.quoteVersionNo).toFixed(0)).subscribe(
      (returnVal: any) => {
        this.ngProgress.done();
      }
    );
  }

  sortData(sort: Sort) {
    const data = this.openQuotes.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedData = data;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'validTo': return compare(a.validTo.split('-').reverse().join('-'), b.validTo.split('-').reverse().join('-'), isAsc);
        case 'quoteId': return compare(parseInt(a.quoteId), parseInt(b.quoteId), isAsc);
        case 'quoteVersionNo': return compare(parseInt(a.quoteVersionNo), parseInt(b.quoteVersionNo), isAsc);
        case 'quoteName': return compare(a.quoteName.toLowerCase(), b.quoteName.toLowerCase(), isAsc);
        case 'quoteTotal': return compare(parseInt(a.quoteTotal), parseInt(b.quoteTotal), isAsc);
        case 'brand': return compare(a.out_brand.toLowerCase(), b.out_brand.toLowerCase(), isAsc);
        case 'endUser': return compare(a.out_end_user_name.toLowerCase(), b.out_end_user_name.toLowerCase(), isAsc);

        default: return 0;
      }
    });
  }

  sortByDescendAscend(comparedProperty: string, sortingOrder: string) {
    switch (comparedProperty) {
      case 'validTo':
        this.sortingInfoObj.comparedProperty = 'validTo';
        break;
    }

    if (sortingOrder === "descending") {
      this.sortingInfoObj.sortingOrder = 'descending';
    } else {
      this.sortingInfoObj.sortingOrder = 'ascending';
    }
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.quotes, ['quoteId', 'quoteVersionNo', 'quoteName', 'validTo', 'quoteTotal'], this.filterInput);
    if (this.filterResultArr.length === 0 && this.filterInput !== "") {
      this.hasEmptyFilterResult = true;
    } else {
      this.hasEmptyFilterResult = false;
    }
  }
  filterReset() {
    this.filterInput = '';
    this.hasEmptyFilterResult = false;
  }
}


function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}


